/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import { loadLanguageAsync } from '@/i18n'

export default {
  showModalLogin (state, visible) {
    state.modalLogin = visible
  },
  showModalRegister (state, visible) {
    state.modalRegister = visible
  },
  setLocale (state, { locale: newLocale, storeViewCode, rootState }) {
    state.locale = newLocale
    state.storeViewCode = storeViewCode
    global.$i18n.locale = newLocale.substr(0, 2)
    if (process.client) {
      loadLanguageAsync(global.$i18n.locale, storeViewCode, newLocale).then(messages => {
        state.messages = messages
      })
      global.$cookies.set('i18n', newLocale)
    }
    global.$locale = state.locale
  },
  setCodeLang (state, codeLang) {
    state.codeLang = codeLang
  },
  urlCode (state, urlCode) {
    state.urlCode = urlCode
  },
  setStoreViewCode (state, storeViewCode) {
    state.storeViewCode = storeViewCode
  },
  setCookieTime (state, showCookie) {
    global.$cookies.set('cookieNotifyShowed', showCookie)
    state.cookieNotifyShowed = showCookie
  },
  showLoader (state, msg = '') {
    state.loaderMsg = msg
    state.loader = true
  },
  hideLoader (state) {
    state.loader = false
    state.loaderMsg = ''
  },
  loadingMiniCart (state, visible) {
    state.loadingMiniCart = visible
  },
  showMiniCart (state, visible) {
    state.showMiniCart = visible
  },
  showRightNav (state, visible) {
    state.showRightNav = visible
  },
  saveMenu (state, menu) {
    state.menu = menu
  },
  setIsMobile (state, isMobile) {
    state.isMobile = isMobile
  },
  showSearch (state, show) {
    state.showSearch = show
  },
  setCountries (state, countries) {
    state.countries = countries
  },
  setCountry (state, country) {
    state.currentCountry = country
  },
  setStateArea (state, area) {
    state.currentState = area
  },
  setShowCountriesModal (state, booleanValue) {
    state.showCountriesModal = booleanValue
  },
  sizeCountrySelected (state, sizeCountrySelected) {
    state.sizeCountrySelected = sizeCountrySelected
  },
  setHrefLang (state, hrefLangs) {
    state.hrefLang = hrefLangs
  },
  setRobots (state, robots) {
    state.metaRobots = robots
  },
  setJsonLD (state, jsonLD) {
    state.jsonLD = jsonLD
  },
  setCanonical (state, canonical) {
    state.canonical = canonical
  },
  setBreadcrumb (state, breadcrumb) {
    state.breadcrumb = breadcrumb
  },
  redirect (state, redirect) {
    state.redirect = redirect
  },
  setListingColumns (state, columns) {
    state.listingColumns = columns
  },
  messagesLocale: (state, messages) => { state.messages = messages }
}
